import React from 'react';
import './Project.css';

const projects = [
  {
    title: 'Code4Life - Social Platform',
    date: 'Oct 20, 2024', // This line can be removed
    description:
      'Initially, Code4Life was a social platform that I co-developed with a team of 4 members, where I contributed as a full-stack developer. After a year, I decided to rebuild it as part of my final project with a new team, enhancing its features and vision to better serve the IT community.',
    tools: ['ReactJS', 'Tailwind CSS', 'Spring Boot', 'MongoDB'],
    role: 'Full Stack Developer',
    teamSize: 1,
    links: { code: 'https://github.com/taovietducofficial/SOCIALMEDIA-CODE4LIFE.git', demo: '#' },
    image: '/Screenshot 2024-12-10 150542.png',
    achievements: [
      'Implemented secure user authentication and authorization using JWT for Storeshoes',
      'Designed and built RESTful APIs to manage product listings, orders, and user interactions',
      'Integrated payment gateway for secure online transactions'
    ]
  },
  {
    title: 'Passport renewal Website',
    date: 'Oct 25, 2024', // This line can be removed
    description:
      'This is a website I developed as a final project, focused on simplifying the passport renewal process. The platform allows users to submit renewal applications, track their application status, and manage personal information. Admins can efficiently oversee and process applications, as well as manage user records and application data.',
    tools: ['ReactJS', 'Tailwind CSS', 'Spring Boot', 'OracleDB'],
    role: 'Full Stack Developer',
    teamSize: 1,
    links: { code: 'https://github.com/taovietducofficial/DataSecurity-FinalProject.git', demo: '#' },
    image: '/Screenshot 2024-12-10 143428.png',
    achievements: [
      'Developed a responsive user interface using React and Tailwind to ensure seamless user experience across devices',
      'Implemented secure document submission and verification systems for passport renewal applications',
      'Built an admin dashboard for efficient management of user applications and status tracking'
    ]
  },
  {
    title: 'Storeshoes Website',
    date: 'Jun 13, 2024', // This line can be removed
    description:
      'Initially, Storeshoes was an e-commerce platform that I developed as a solo project, where I handled both the front-end and back-end development. After a year, I decided to rebuild it as part of my final project, enhancing its functionality and user experience to better cater to the needs of online shoppers.',
    tools: ['ReactJS', 'Spring Boot', 'MySQL'],
    role: 'Full Stack Developer',
    teamSize: 1,
    links: { code: 'https://github.com/taovietducofficial/SHOES-SHOP-WEBSITE.git', demo: '#' },
    image: '/Screenshot 2024-12-10 150242.png',
    achievements: [
      'Implemented secure user authentication and authorization using JWT for Storeshoes',
      'Designed and built RESTful APIs to manage product listings, orders, and user profiles',
      'Integrated real-time features using WebSocket for instant order updates and customer notifications'
    ]
  },
  {
    title: 'PROJECT DATAWAREHOUSE',
    date: 'Dec 3, 2024', // This line can be removed
    description:
      'Developed and built an application to analyze and extract insights, aiming to understand the trends of universities and assess their effectiveness for different target groups.',
    tools: ['Visual Studio 2022', 'SQL Server Integration Services (SSIS)', 'SQL Server Data Tools (SSDT)', 'SQL Server 2019', 'SQL', 'Python', 'Visual Studio Code'],
    role: 'Full Stack Developer',
    teamSize: 1,
    links: { code: 'https://github.com/taovietducofficial/FINAL-PROJECT-DATAWAREHOUSE.git', demo: '#' },
    image: '/Screenshot 2024-12-10 145347.png',
    achievements: [
      'Implemented secure data ingestion and transformation systems for efficient data processing in the data warehouse', 
      'The project focuses primarily on the fundamental theories of building a data warehouse. It applies knowledge of data analysis and necessary business processes, modeling business logic, and integrating data into the warehouse using SSIS. The project also involves performing analysis with SSAS, answering business questions through SSAS, Pivot Excel, and Power BI.'
    ]
  },
  {
    title: 'TopWayVN-Website',
    date: 'Dec 23, 2023', // This line can be removed
    description:
      'TopWayVN is a travel website that I developed as a final project, focusing on providing users with travel guides, itineraries, and recommendations for popular destinations in Vietnam. The platform aims to inspire travel enthusiasts and help',
    tools: ['ReactJS'],
    role: 'Front-end Developer',
    teamSize: 2,
    links: { code: 'https://github.com/taovietducofficial/TopWayVN-Website.git', demo: '#' },
    image: '/download.jfif',
    achievements: [
      'Design front-end components and user interface for the website, ensuring a seamless user experience across devices',
    ]
  },
];

const Project = () => {
  return (
    <div className="project-container">
      <h2 className="project-title">Projects Me</h2>
      <div className="timeline">
        <div className="timeline-line"></div>
        {projects.map((project, index) => (
          <div
            key={index}
            className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}
          >
            <div className="timeline-dot">
              <span className="dot"></span>
              {/* Removed the date section */}
            </div>
            <div className="timeline-content">
              <div className="project-card">
                <div className="project-header">
                  <h3 className="project-name">{project.title}</h3>
                </div>

                <div className="project-image">
                  <img src={project.image} alt={project.title} loading="lazy" />
                </div>

                <p className="project-description">{project.description}</p>

                <div className="project-details">
                  <div className="tools-section">
                    <h4>Technologies Used</h4>
                    <div className="tools-list">
                      {project.tools.map((tool, idx) => (
                        <span key={idx} className="tool-tag">{tool}</span>
                      ))}
                    </div>
                  </div>

                  <div className="role-info">
                    <p><strong>Role:</strong> {project.role}</p>
                    <p><strong>Team Size:</strong> {project.teamSize} people</p>
                  </div>

                  <div className="achievements-section">
                    <h4>Key Achievements</h4>
                    <ul>
                      {project.achievements.map((achievement, idx) => (
                        <li key={idx}>{achievement}</li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div className="project-links">
                  <a
                    href={project.links.code}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-button code-link"
                  >
                    View Code
                  </a>
                  {/* <a
                    href={project.links.demo}
                    target="_blank"
                    rel="noopener noreferrer" 
                    className="link-button demo-link"
                  >
                    Live Demo
                  </a> */}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Project;
